import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export const GA_ID = 'G-4FVB1MZHGJ'

// NEW: helper to fire custom events
export function trackEvent(action, params = {}) {
  if (
    typeof window !== 'undefined' &&
    window.gtag &&
    localStorage.getItem('cookieConsent') === 'true'
  ) {
    window.gtag('event', action, params)
  }
}

const Analytics = () => {
  const location = useLocation()

  useEffect(() => {
    if (typeof window === 'undefined') return
    const consent = localStorage.getItem('cookieConsent')
    if (consent !== 'true' && window.ga) {
      window['ga-disable-' + GA_ID] = true
    }
  }, [])

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      window.gtag &&
      localStorage.getItem('cookieConsent') === 'true'
    ) {
      window.gtag('config', GA_ID, {
        page_path: location.pathname + location.search
      })
    }
  }, [location])

  return null
}

export default Analytics